






































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { ContractsListParams } from "@/getinfo-api/contracts";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { Contract as IContract } from "@/api/models/contract";
import { Employee as IEmployee } from "@/api/models/employee";
import ContractListItem from "@/components/contract/ContractListItem.vue";
import { isRoot, getCurrentCompanyId } from "@/plugins/roles";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { UsersListClass } from "@/classes/list/UsersListClass";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import { ContractSort, SortFields } from "@/plugins/sort-fields";

@Component({
  components: {
    CSingleSelect,
    CBlock,
    CField,
    CPage,
    CustomButton,
    CustomTable,
    ContractListItem,
    SelectEntity,
    CustomDatepicker
  }
})
export default class ContractList extends Vue {
  contractType!: string | undefined;
  contractorType!: string | undefined;
  contractorId!: string | undefined; // контрагент
  responsible!: IEmployee | undefined; // ответственный
  showSpinner: boolean = false;
  documentsManagers: EmployeesListClass = new EmployeesListClass({
    id: this.selectedCompany,
    roles: ["document_manager"]
  });
  users: UsersListClass = new UsersListClass();
  sorted: SortFields<ContractSort> = new SortFields(ContractSort.formedAt);
  form: ContractsListParams = {
    number: undefined,
    type: undefined,
    responsibleId: undefined,
    formedAtMin: undefined,
    formedAtMax: undefined,
    contractorId: undefined,
    contractorType: undefined,
    isSignedAt: undefined,
    companyId: this.selectedCompany,
    sort: this.sorted.sort,
    order: this.sorted.order
  };
  contractorList: ContractorsListClass = new ContractorsListClass({
    companyId: this.selectedCompany
  });
  data() {
    return {
      contractType: undefined,
      contractorType: undefined,
      number: undefined,
      contractorId: undefined,
      responsible: undefined,
      formedAtMin: undefined,
      formedAtMax: undefined
    };
  }

  @Watch("form.contractorType")
  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = this.form.contractorType
      ? this.form.contractorType
      : undefined;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  acceptSort(sort: ContractSort) {
    this.sorted.changeSort(sort);
    this.form.sort = this.sorted.sort;
    this.form.order = this.sorted.order;
    this.applyFilter();
  }

  get sortStatus() {
    return ContractSort;
  }

  clearForm() {
    this.form = {
      companyId: this.selectedCompany,
      formedAtMin: undefined,
      formedAtMax: undefined,
      contractorId: undefined,
      contractorType: undefined,
      isSignedAt: undefined,
      sort: this.sorted.sort,
      order: this.sorted.order
    } as ContractsListParams;
    this.responsible = undefined;
    this.$store.commit("contracts/CLEAR");
    this.searchContracts();
  }

  showMore() {
    this.searchContracts();
  }

  get contracts(): Array<IContract> {
    return this.$store.getters["contracts/GET_LIST"];
  }

  get contractsCount() {
    return this.$store.getters["contracts/GET_COUNT"];
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get documentManager() {
    return this.$store.getters.roles.includes("document_manager");
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  applyFilter() {
    this.$store.commit("contracts/CLEAR");
    this.searchContracts();
  }

  async searchContracts() {
    this.showSpinner = true;
    if (this.responsible) {
      this.form.responsibleId = this.responsible.id;
    }
    await this.$store.dispatch("contracts/LIST", this.form);
    this.showSpinner = false;
  }

  @Watch("selectedCompany")
  updateList() {
    this.clearForm();
    if (this.selectedCompany) {
      this.documentsManagers = new EmployeesListClass({
        id: this.selectedCompany,
        roles: ["document_manager"]
      });
    }
  }

  created() {
    this.$store.commit("contracts/CLEAR");
    this.searchContracts();
  }
}
